import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export const imageStyles = { opacity: '0.1' };

const styles = css`
  @keyframes backgroundShimmer1 {
    0% {
      background: ${colors.G1};
    }
    100% {
      background: ${colors.G2};
    }
  }

  @keyframes backgroundShimmer2 {
    0% {
      background: ${colors.G2};
    }

    100% {
      background: ${colors.G1};
    }
  }

  .search-result {
    display: flex;
    flex-direction: column;
    background-color: ${colors.WHITE};
    width: 100%;
    height: auto;
    border-radius: 8px;
  }

  @media (min-width: ${screen.smMin}) {
    .search-result {
      height: 200px;
      max-width: 1038px;
      flex-direction: row;
      border-radius: 16px;
      border: 1px ${colors.G2} solid;
    }
  }

  .images-container {
    height: 100%;
    border-radius: 8px;
    margin: 16px 16px 8px 16px;
    background-repeat: no-repeat;
    background-size: cover;
    animation: backgroundShimmer2 0.7s ease-in-out infinite alternate;
  }

  .images-container img {
    opacity: 0.1;
  }

  @media (min-width: ${screen.smMin}) {
    .images-container {
      width: 284px;
      min-width: 284px;
      height: 168px;
      margin: 16px 24px 16px 16px;
    }
  }

  .placeholder-details {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 8px 16px 0 16px;
  }

  @media (min-width: ${screen.smMin}) {
    .placeholder-details {
      width: 100%;
      margin: 16px 24px 16px 0;
    }
  }

  .bar {
    height: 16px;
    border-radius: 4px;
    margin-bottom: 16px;
  }

  .xl {
    width: 100%;
  }

  .l {
    width: 80%;
  }

  .m {
    width: 60%;
  }

  .s {
    width: 50%;
  }

  .xs {
    width: 40%;
  }

  .placeholder-left {
    display: flex;
    flex-direction: column;
    position: relative;
    flex-basis: 40%;
  }

  .placeholder-left .bar,
  .third {
    animation: backgroundShimmer1 0.7s ease-in-out infinite alternate;
  }

  .placeholder-left .third {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .placeholder-left .third {
      display: flex;
    }

    .placeholder-left .last {
      position: absolute;
      bottom: 0px;
    }
  }

  .placeholder-middle {
    display: none;
    flex-basis: 40%;
  }

  @media (min-width: 920px) {
    .placeholder-middle {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin: 0 55px 0 56px;
    }

    .placeholder-middle .bar {
      animation: backgroundShimmer2 0.7s ease-in-out infinite alternate;
    }
  }

  .placeholder-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-basis: 20%;
  }

  .placeholder-right .bar {
    animation: backgroundShimmer2 0.7s ease-in-out infinite alternate;
  }

  @media (min-width: 920px) {
    .placeholder-right .bar {
      animation: backgroundShimmer1 0.7s ease-in-out infinite alternate;
    }
  }
`;
export default styles;
